import { SDLUtil, RequestUtil } from '@/utils';

// louis
/* 실패 로그 목록 변이 실행 * */
const setFailLogList = ({ commit }, data) => {
  commit('SET_FAIL_LOG_LIST', data);
};

export default {
  // louis
  /* Fail Log Actions. start * */
  /* 초기화 * */
  initData({ commit }, data) {
    commit('INIT_DATA', data);
  },

  /* 실패 로그 목록 조회 * */
  async getFailLogList(store, params) {
    let question = '?';
    const paramUri = [];
    for (const [key] of Object.entries(params)) {
      paramUri.push(`${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`);
    }

    const response = await RequestUtil.get(`${SDLUtil.API_URL}/rem/log/GetFailLogList${question}${paramUri.join('&')}`);
    const failLogList = response.data.data;
    setFailLogList(store, failLogList);
    return response;
  },

  /* 실패한 데이터 재실행 * */
  async updateRetry(store, params) {
    // if (params.length == undefined) params = [params];
    const response = await RequestUtil.post(`${SDLUtil.API_URL}/rem/log/UpdateRetryFail`, params);

    return response;
  },
  /* Fail Log Actions. end * */

};



// WEBPACK FOOTER //
// ./src/vuex/rem/log/logActions.js